/**
 * doing `Object.keys` is often frustrating with TS. This utility
 * helps to keep your code TS and easy to write. It has the same result
 * as `Object.keys`. Using this you should be able to index your object
 */
export const keys = <T extends Record<string, unknown>>(obj: T) =>
  Object.keys(obj) as Array<keyof T>;
